export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4657.62648d27.jpg";